import { useCallback, useContext } from 'react';
import { createOrUpdateCampaign } from '@bingads-webui-campaign-react/perf-max-data';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import Promise from 'bluebird';

const DEFAULT_CAMPAIGN_NAME = `Performance-Max-${Math.floor(Math.random() * 100)}`;

export function usePmaxCampaignAPI() {
  const { scope } = useContext(ScopeContext);
  const { campaignId } = scope.values;
  const createOrUpdateCampaignPromise = useCallback(({ Name, Language, Status } = { Name: DEFAULT_CAMPAIGN_NAME, Language: 'English', Status: 'Active' }) => {
    const campaignData = {
      Name,
      Status,
      Budget: {
        Amount: 25,
        Type: 'DailyStandard',
      },
      TimeZone: 'PacificTimeUSCanadaTijuana',
      CampaignType: 'PerformanceMax',
      BiddingScheme: {
        Type: 'MaxConversions', // Enhanced CPC will be supported for Performance Max campaigns in Q1
      },
      Languages: [Language],
    };

    let campaignPromise = () => Promise.resolve();
    if (!campaignId) {
      campaignPromise = () => createOrUpdateCampaign(campaignData).then((campaign) => {
        scope.append({ campaignId: campaign.Id });
        scope.history.replace({
          pathname: scope.history.location.pathname,
          search: scope.stringify(),
        });
        return campaign;
      });
    }

    return campaignPromise();
  }, [campaignId, scope]);

  return {
    createOrUpdateCampaignPromise,
  };
}
